import base from "../../../base";

export default async function fetchTreeInfo(treeID) {
	const treeInfo = base.fetch(`trees/${treeID}/treeInfo`, { context: this });
	return treeInfo;
}
